import React from "react";
import { Box } from "common";
import offerDiscountImg from "../../../assets/offerDiscount.png";
import longTextImg from "../../../assets/longText.png";
import shortTextImg from "../../../assets/shortText.png";

const BundleHelp = () => {
  return (
    <Box gridTemplateColumns="1fr 1fr 1fr" gridGap="25px">
      {[shortTextImg, longTextImg, offerDiscountImg]?.map((url) => {
        let imgName = url?.split("/")?.[3]?.split(".")?.[0];
        let altText = imgName
          ?.replace(/([a-z])([A-Z])/g, "$1 $2")
          .toLowerCase();
        return (
          <img
            key={imgName}
            src={url}
            alt={altText}
            width="100%"
            style={{ border: "1px solid black", borderRadius: "15px" }}
          />
        );
      })}
    </Box>
  );
};

export default BundleHelp;